module.exports = __webpack_public_path__ + "img/oncologie.a8156806.png";